import React, { useEffect, useContext, useState } from 'react';
/*import Subwindow_Modal_AccountManagement_Account_Add from './Subwindow_Modal_AccountManagement_Account_Add'*/
import { Context_UI } from '../Contexts/Context_UI';
import SubwindowModalRegisterRequestSent from './Subwindow_Modal_Register_RequestSent'
import Subwindow_MapEditor_Add from './MapEditor/Subwindow_MapEditor_Add';
import Subwindow_MapEditor_RippleDelete from './MapEditor/Subwindow_MapEditor_RippleDelete';
import Subwindow_Modal_UnsavedChanges from './Subwindow_Modal_UnsavedChanges';
import Subwindow_ScheduleManagement_Reserve from './ScheduleManagement/Subwindow_ScheduleManagement_Reserve';
import Subwindow_ScheduleManagement_Attendees from './ScheduleManagement/Subwindow_ScheduleManagement_Attendees';
import Subwindow_ScheduleManagement_Equipment from './ScheduleManagement/Subwindow_ScheduleManagement_Equipment';
import Subwindow_MapEditor_Restore from './MapEditor/Subwindow_MapEditor_Restore';
import Subwindow_ScheduleManagement_Map from './ScheduleManagement/Subwindow_ScheduleManagement_Map';
import Subwindow_ScheduleManagement_Reservation_Success from './ScheduleManagement/Subwindow_ScheduleManagement_Reservation_Success';
import Subwindow_ScheduleManagement_Document from './ScheduleManagement/Subwindow_ScheduleManagement_Document';
import Subwindow_ScheduleManagement_Reservation_Reject from './ScheduleManagement/Subwindow_ScheduleManagement_Reservation_Reject';
import Subwindow_ScheduleManagement_Conflict_Resolve_Standard from './ScheduleManagement/Subwindow_ScheduleManagement_Conflict_Resolve_Standard';
import Subwindow_ScheduleManagement_Schedule_Reschedule from './ScheduleManagement/Manager/Subwindow_ScheduleManagement_Schedule_Reschedule';
import Subwindow_ScheduleManagement_Schedule_Relocate from './ScheduleManagement/Manager/Subwindow_ScheduleManagement_Schedule_Relocate';
import Subwindow_ScheduleManagement_Schedule_Edit from './ScheduleManagement/Manager/Subwindow_ScheduleManagement_Schedule_Edit';
import Subwindow_ScheduleManagement_Schedule_Approve from './ScheduleManagement/Manager/Subwindow_ScheduleManagement_Schedule_Approve';
import Subwindow_ScheduleManagement_Schedule_Approve_Delegate from './ScheduleManagement/Manager/Subwindow_ScheduleManagement_Schedule_Approve_Delegate';

export default function UI_Subwindows() {
    const UI = useContext(Context_UI);
    const [Active, Active_Set] = useState(UI.Subwindows_ActiveSubwindows);
    const [Current, Current_Set] = useState(UI.Subwindows_CurrentlyActiveSubwindow);

    useEffect(() => {
        const Handle_Open = ({ Subwindows_Active: arr, Subwindows_Current }) => {
            Active_Set([...arr]);
            Current_Set(Subwindows_Current);
            console.error(Active.indexOf(Subwindows_Current));
        };
        const Handle_Close = ({ Subwindows_Active: arr, Subwindows_Current }) => {
            Active_Set([...arr]);
            Current_Set(Subwindows_Current);
        };

        UI.on("Subwindow_Opened", Handle_Open);
        UI.on("Subwindow_Closed", Handle_Close);

        return () => {
            UI.off("Subwindow_Opened", Handle_Open);
            UI.off("Subwindow_Closed", Handle_Close);
        };
    }, [UI]);

    return (
        <ui-subwindows id="Subwindows">
            {Active.includes("Window_Register_Success") && (
                <SubwindowModalRegisterRequestSent
                    zIndex={Active.indexOf("Window_Register_Success") + 1}
                    isActive={Current === "Window_Register_Success"}
                    id="Window_Register_Success"
                />
            )}
            {Active.includes("Window_MapEditor_Add") && (
                <Subwindow_MapEditor_Add
                    zIndex={Active.indexOf("Window_MapEditor_Add") + 1}
                    isActive={Current === "Window_MapEditor_Add"}
                    id="Window_MapEditor_Add"
                />
            )}
            {Active.includes("Window_General_UnsavedChanges") && (
                <Subwindow_Modal_UnsavedChanges
                    zIndex={Active.indexOf("Window_General_UnsavedChanges") + 1}
                    isActive={Current === "Window_General_UnsavedChanges"}
                    id="Window_General_UnsavedChanges"
                />
            )}
            {Active.includes("Window_MapEditor_RippleDelete") && (
                <Subwindow_MapEditor_RippleDelete
                    zIndex={Active.indexOf("Window_MapEditor_RippleDelete") + 1}
                    isActive={Current === "Window_MapEditor_RippleDelete"}
                    id="Window_MapEditor_RippleDelete"
                />
            )}
            {Active.includes("Window_MapEditor_Restore") && (
                <Subwindow_MapEditor_Restore
                    zIndex={Active.indexOf("Window_MapEditor_Restore") + 1}
                    isActive={Current === "Window_MapEditor_Restore"}
                    id="Window_MapEditor_Restore"
                />
            )}
            {Active.includes("Window_ScheduleManagement_Reserve") && (
                <Subwindow_ScheduleManagement_Reserve
                    zIndex={Active.indexOf("Window_ScheduleManagement_Reserve") + 1}
                    isActive={Current === "Window_ScheduleManagement_Reserve"}
                    id="Window_ScheduleManagement_Reserve"
                    inert={Current == "Window_ScheduleManagement_Reserve" ? "" : undefined}
                />
            )}
            {Active.includes("Window_ScheduleManagement_Conflict_Resolve_Standard") && (
                <Subwindow_ScheduleManagement_Conflict_Resolve_Standard
                    zIndex={Active.indexOf("Window_ScheduleManagement_Conflict_Resolve_Standard") + 1}
                    isActive={Current === "Window_ScheduleManagement_Conflict_Resolve_Standard"}
                    id="Window_ScheduleManagement_Conflict_Resolve_Standard"
                    inert={Current == "Window_ScheduleManagement_Conflict_Resolve_Standard" ? "" : undefined}
                />
            )}
            {Active.includes("Window_ScheduleManagement_Schedule_Reschedule") && (
                <Subwindow_ScheduleManagement_Schedule_Reschedule
                    zIndex={Active.indexOf("Window_ScheduleManagement_Schedule_Reschedule") + 1}
                    isActive={Current === "Window_ScheduleManagement_Schedule_Reschedule"}
                    id="Window_ScheduleManagement_Schedule_Reschedule"
                    inert={Current == "Window_ScheduleManagement_Schedule_Reschedule" ? "" : undefined}
                />
            )}
            {Active.includes("Window_ScheduleManagement_Schedule_Relocate") && (
                <Subwindow_ScheduleManagement_Schedule_Relocate
                    zIndex={Active.indexOf("Window_ScheduleManagement_Schedule_Relocate") + 1}
                    isActive={Current === "Window_ScheduleManagement_Schedule_Relocate"}
                    id="Window_ScheduleManagement_Schedule_Relocate"
                    inert={Current == "Window_ScheduleManagement_Schedule_Relocate" ? "" : undefined}
                />
            )}
            {Active.includes("Window_ScheduleManagement_Schedule_Edit") && (
                <Subwindow_ScheduleManagement_Schedule_Edit
                    zIndex={Active.indexOf("Window_ScheduleManagement_Schedule_Edit") + 1}
                    isActive={Current === "Window_ScheduleManagement_Schedule_Edit"}
                    id="Window_ScheduleManagement_Schedule_Edit"
                    inert={Current == "Window_ScheduleManagement_Schedule_Edit" ? "" : undefined}
                />
            )}
            {Active.includes("Window_ScheduleManagement_Attendees") && (
                <Subwindow_ScheduleManagement_Attendees
                    zIndex={Active.indexOf("Window_ScheduleManagement_Attendees") + 1}
                    isActive={Current === "Window_ScheduleManagement_Attendees"}
                    id="Window_ScheduleManagement_Attendees"
                    inert={Current == "Window_ScheduleManagement_Attendees" ? "" : undefined}
                />
            )}
            {Active.includes("Window_ScheduleManagement_Equipment") && (
                <Subwindow_ScheduleManagement_Equipment
                    zIndex={Active.indexOf("Window_ScheduleManagement_Equipment") + 1}
                    isActive={Current === "Window_ScheduleManagement_Equipment"}
                    id="Window_ScheduleManagement_Equipment"
                    inert={Current == "Window_ScheduleManagement_Equipment" ? "" : undefined}
                />
            )}
            {Active.includes("Window_ScheduleManagement_Map") && (
                <Subwindow_ScheduleManagement_Map
                    zIndex={Active.indexOf("Window_ScheduleManagement_Map") + 1}
                    isActive={Current === "Window_ScheduleManagement_Map"}
                    id="Window_ScheduleManagement_Map"
                    inert={Current == "Window_ScheduleManagement_Map" ? "" : undefined}
                />
            )}
            {Active.includes("Window_ScheduleManagement_Reserve_Success") && (
                <Subwindow_ScheduleManagement_Reservation_Success
                    zIndex={Active.indexOf("Window_ScheduleManagement_Reserve_Success") + 1}
                    isActive={Current === "Window_ScheduleManagement_Reserve_Success"}
                    id="Window_ScheduleManagement_Reserve_Success"
                    inert={Current == "Window_ScheduleManagement_Reserve_Success" ? "" : undefined}
                />
            )}
            
            {Active.includes("Window_ScheduleManagement_Document") && (
                <Subwindow_ScheduleManagement_Document
                    zIndex={Active.indexOf("Window_ScheduleManagement_Document") + 1}
                    isActive={Current === "Window_ScheduleManagement_Document"}
                    id="Window_ScheduleManagement_Document"
                    inert={Current == "Window_ScheduleManagement_Document" ? "" : undefined}
                />
            )}
            {Active.includes("Window_ScheduleManagement_Reserve_Reject") && (
                <Subwindow_ScheduleManagement_Reservation_Reject
                    zIndex={Active.indexOf("Window_ScheduleManagement_Reserve_Reject") + 1}
                    isActive={Current === "Window_ScheduleManagement_Reserve_Reject"}
                    id="Window_ScheduleManagement_Reserve_Reject"
                    inert={Current == "Window_ScheduleManagement_Reserve_Reject" ? "" : undefined}
                />
            )}
            {Active.includes("Window_ScheduleManagement_Reserve_Approve") && (
                <Subwindow_ScheduleManagement_Schedule_Approve
                    zIndex={Active.indexOf("Window_ScheduleManagement_Reserve_Approve") + 1}
                    isActive={Current === "Window_ScheduleManagement_Reserve_Approve"}
                    id="Window_ScheduleManagement_Reserve_Approve"
                    inert={Current == "Window_ScheduleManagement_Reserve_Approve" ? "" : undefined}
                />
            )}
            {Active.includes("Window_ScheduleManagement_Reserve_Approve_Delegate") && (
                <Subwindow_ScheduleManagement_Schedule_Approve_Delegate
                    zIndex={Active.indexOf("Window_ScheduleManagement_Reserve_Approve_Delegate") + 1}
                    isActive={Current === "Window_ScheduleManagement_Reserve_Approve_Delegate"}
                    id="Window_ScheduleManagement_Reserve_Approve_Delegate"
                    inert={Current == "Window_ScheduleManagement_Reserve_Approve_Delegate" ? "" : undefined}
                />
            )}
            
            
        </ui-subwindows>
    );
}
